import React from 'react';
import { formatDay, formatTime, formatTs } from './advisors';

// Date on one line, the muted IST time under it; the full stamp is the tooltip.
function Stamp({ iso }: { iso: string | null | undefined }) {
  const time = formatTime(iso);
  return (
    <span title={iso ? formatTs(iso) : undefined}>
      <span className="block">{formatDay(iso)}</span>
      {time ? <span className="block text-xs text-content-muted">{time}</span> : null}
    </span>
  );
}

export default Stamp;
